import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import {
  getCrmSupplierContactQuotasEndpointIdentifier,
  ICrmSupplierContactQuotaData,
} from './use-get-crm-supplier-contact-quotas-api';

const endpoint = 'ums/v1/crm/management/suppliers/contact-quotas';

export type CreateCrmSupplierContactQuotaPayload = {
  supplierId: number;
  quota: number;
  remaining: number;
};

type TData = ICrmSupplierContactQuotaData;
type TError = AxiosError;
type TVariables = CreateCrmSupplierContactQuotaPayload;

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

export function useCreateCrmSupplierContactQuotaApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async (payload: TVariables): Promise<TData> => {
    const { data } = await http.post(endpoint, payload);
    return data;
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: endpoint,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([getCrmSupplierContactQuotasEndpointIdentifier]);
      if (userOnSuccess) {
        userOnSuccess(data, variables, context);
      }
    },
    ...restOptions,
  });
}
